export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.23-1520.25",
  commitId: "4f8644577cb6e75c81839f0d7cbdd038bb6f4cd9",
  commitTime: "2026-09-23T15:20:25.000Z",
});
